module.exports = require('./PromotionPopupList');